module.exports = __webpack_public_path__ + "img/banner2.8e9be8e8.svg";